import React from 'react'

import { Heading4, Body3, Space } from '@gousto-internal/citrus-react'

import menu from 'config/menu'
import { sanitize } from 'utils/sanitizer'

type AllergensProps = {
  labelHtml?: string
}

export const Allergens = ({ labelHtml }: AllergensProps) => (
  <>
    <Heading4>Allergens</Heading4>
    <Space size={4} />
    {labelHtml ? (
      <Body3 data-testing="allergen" dangerouslySetInnerHTML={{ __html: sanitize(labelHtml) }} />
    ) : null}
    <Body3>{menu.legal}</Body3>
  </>
)
